export const ru = {
    'adaptive-banner': 'Адаптивное объявление',
    additions: 'Дополнения: {additionsList}',
    'banner-id': '№ {id}',
    duration: '{duration} сек'
};
